/* eslint-env browser */
/* eslint-disable no-console no-throw-literal*/
import axios from "../axios";
import {toast} from 'react-toastify';
import * as apiTypes from '../constants/ApiConstants';
import * as types from '../constants/ActionTypes';
import * as validationTypes from '../constants/ValidationConstants';
import Invoice from '../models/Invoice';
import AddressData from '../models/payer/address_data';
import CompanyData from '../models/payer/company_data';
import Details from '../models/payer/details';
import PaymentCard from '../models/payer/payment_card';
import PaymentStatus from '../models/payer/PaymentStatus';
import Data from '../models/payer/data';
import {
  requestErrored,
  requestStarted,
  requestUnauthorized,
  updateState
} from './CommonActions';
import * as appConstants from '../constants/ApplicationConstants';
import * as Yup from "yup";

function mapDocumentsToInvoice(documentList) {
  return documentList.map(document => {
    return new Invoice(document);
  });
}

function mapDistinctCurrencies(documentList) {
  const currencies = [...new Set(documentList.map(document => document.currency_key))];
  return currencies.map(currency => ({
    value: currency,
    label: currency,
    clearableValue: false
  }));
}

export function addInvoiceToSelected(document) {
  return {
    type: types.ADD_INVOICE_TO_SELECTED,
    payload: document
  };
}

export function removeInvoiceFromSelected(document) {
  return {
    type: types.REMOVE_INVOICE_FROM_SELECTED,
    payload: document
  };
}

export function updatePayAmountForInvoice(documentId, amount, openAmount, partialAllowed, overPaymentAllowed) {
  let error = '';
  let overUnder = 0;
  if (amount < openAmount) {
    overUnder = -1;
  }
  if (amount > openAmount) {
    overUnder = 1;
  }

  if (amount === 0) {
    error = 'Amount cannot be zero.';
  } else if (amount === '') {
    error = 'Amount cannot be empty.';
  } else {
    let test = Yup.number();
    let validate = test.isValidSync(amount);
    if(!validate){
      error = 'Only numeric values allowed';
    }
  }
  if (amount < 0) {
    error = 'Amount cannot be negative.';
  }
  if (amount < 0) {
    error = 'Amount cannot be negative.';
  }
  if (amount > openAmount && !overPaymentAllowed) {
    error = 'Over payment not allowed.';
  }
  if (amount < openAmount && !partialAllowed) {
    error = 'Partial payment not allowed.';
  }

  return {
    type: types.UPDATE_PAY_AMOUNT_FOR_INVOICE,
    payload: {
      documentId,
      amount,
      amountValidation: error,
      overUnder: overUnder,
    }
  };
}

export function updateReasonComment(documentId, comment) {
  return {
    type: types.UPDATE_REASON_COMMENT,
    payload: {
      documentId,
      comment
    }
  };
}

export function updateReason(documentId, reason) {
  return {
    type: types.UPDATE_REASON,
    payload: {
      documentId,
      reason
    }
  };
}

export function getInvoicesAjax(invoiceListRequest){
  return  axios
    .post(apiTypes.INVOICE_LIST_URL, invoiceListRequest);
}

export function getInvoices(dispatch, invoiceListRequest) {
  let invoices = [];
  let invoiceCurrencies = [];
  return getInvoicesAjax(invoiceListRequest)
    .then(response => {
      if (
        response.status === 200 &&
        (response.data.status.message_type === 'S' || response.data.status.message_type === 'W')
      ) {
        if (response.data.status.message_type === 'W') {
          toast.warn(response.data.status.message_line_string, {
            position: toast.POSITION.TOP_RIGHT
          });
        }

        if (response.data && response.data.document_list && response.data.document_list.length > 0) {
          invoices = mapDocumentsToInvoice(response.data.document_list);
          invoiceCurrencies = mapDistinctCurrencies(response.data.document_list);
        }

        invoices.forEach(invoice => {
          invoice.soldto_number = parseInt(invoice.soldto_number, 10).toString();
          invoice.payer_number = parseInt(invoice.payer_number, 10).toString();
        });
        updateState(dispatch, types.GET_INVOICES_SUCCESS, invoices);
        updateState(dispatch, types.GET_INVOICE_CURRENCY_SUCCESS, invoiceCurrencies);

        return [invoices, invoiceCurrencies];
      } else {
        updateState(dispatch, types.GET_INVOICES_SUCCESS, []);
        updateState(dispatch, types.GET_INVOICE_CURRENCY_SUCCESS, []);
        if (response.data && response.data.status && response.data.status.message_line_string) {
          toast.error(response.data.status.message_line_string, {
            position: toast.POSITION.TOP_RIGHT
          });
        }
        return [invoices, invoiceCurrencies];
      }
    })
    .catch(err => {
      if (err && err.response && err.response.statusText === 'Unauthorized') {
        requestUnauthorized(dispatch, err);
      } else {
        requestErrored(dispatch, err, validationTypes.GET_INVOICE_ERROR);
      }
    });
}

export function getInvoicePDF(dispatch, invoice) {

  const docNumber = invoice.billing_document_number;
  const input = {'document_detail': {'billing_document_number': `${docNumber}`, 'document_type': '01'}};

  axios
    .post(apiTypes.INVOICE_PDF_URL, input)
    .then(response => {
      if (response.status === 200) {
        // const file = new Blob([response.data], {type: 'application/pdf'});
        // const fileURL = URL.createObjectURL(file, {name: `${docNumber}${'.pdf'}`});
        window.open(response.data, '_blank');
      }
    })
    .catch(err => {
      if (err && err.response && err.response.statusText === 'Unauthorized') {
        requestUnauthorized(dispatch, err);
      } else {
        requestErrored(dispatch, err, validationTypes.GET_INVOICE_PDF_ERROR);
      }
    });
}

export function getInvoiceBulkPDF(dispatch, search) {
    var vGridViewDocIds;
    let data = search;
    if (sessionStorage.getItem("invoicesWithKeysData") != null) {
        vGridViewDocIds = JSON.parse(sessionStorage.getItem("invoicesWithKeysData") || '{}');
        data.search_parameters.GridViewDocIds = vGridViewDocIds;
    }
    axios
        .post(apiTypes.INVOICE_BULK_URL, search)
        .then(response => {
            if (response.status === 200) {
                window.open(response.data, '_blank');
            }
        })
        .catch(err => {
            if (err && err.response && err.response.status === 401) {
                requestUnauthorized(dispatch, err);
            } else {
                requestErrored(dispatch, err, validationTypes.GET_INVOICE_PDF_ERROR);
            }
        });
}
export function getInvoiceSearchPDF(dispatch, search) {

  axios
    .post(apiTypes.INVOICE_SEARCH_PDF_URL, search)
    .then(response => {
      if (response.status === 200) {
        window.open(response.data, '_blank');
      }
    })
    .catch(err => {
      if (err && err.response && err.response.statusText === 'Unauthorized') {
        requestUnauthorized(dispatch, err);
      } else {
        requestErrored(dispatch, err, validationTypes.GET_INVOICE_PDF_ERROR);
      }
    });
}

export function extractLastCardNumbers(str, delim = '-') {
  if(str == null){
    return "";
  }
  const a = str.indexOf(delim, 1);
  if (a === -1) return '';
  const b = str.indexOf(delim, a + 1);
  if (b === -1) return '';
  return str.substr(a + 1, b - a - 1);
}

export function mapCards(cardData, sessionCards, sessionChecks) {

  return cardData.map((card, index) => ({
    value: card.payment_card_token,
    label: `${card.payment_card_type}${'-'}${card.payment_card_name}${'-'}${extractLastCardNumbers(
      card.payment_card_token,
      '-'
    )}`,
    clearableValue: false,
    cardType: card.payment_card_type,
    index: index
  }));
}

export function getPayerDetailsBuilder(dispatch, primary, secondary, accountType) {
  let request;
  if (accountType === appConstants.SOLD_TO_COMPARE) {
    // Use Secondary Account
    request = {
      customer_number: secondary && secondary.PrimaryAcct,
      company_code: primary && primary.CompanyCode,
      action: '',
      sales_area_data: {
        sales_organization: secondary && secondary.SalesOrganization,
        distribution_channel: secondary && secondary.DistributionChannel,
        division: secondary && secondary.Division
      }
    };
  } else {
    // Use Primary Account
    request = {
      customer_number: primary && primary.PrimaryAcct,
      company_code: primary && primary.CompanyCode,
      action: '',
      sales_area_data: {
        sales_organization: primary && primary.SalesOrganization,
        distribution_channel: primary && primary.DistributionChannel,
        division: primary && primary.Division
      }
    };
  }
  getPayerDetails(dispatch, request);
}

export function getPayerDetails(dispatch, input) {
  axios
    .post(apiTypes.PAYER_DETAILS_URL, input)
    .then(response => {
        if (response.status === 200 && response.data.status.message_type === 'S') {
          if (response.data) {
            const addressdata = new AddressData(response.data.detail.address_data);
            
            let cardData = [];
            cardData = response.data.detail.payment_cards.map(card => {
              card.default = card.default === "X";
              return new PaymentCard(card);
            });

            if (!response.data.detail && !response.data.detail.company_data) {
              throw ("No Company Data Found");
            }
            const CompanyDatas = response.data.detail.company_data.map(_ => {
              const data = new Data(_.company_code);
              return new CompanyData(data);
            });

            const soldtos = [];
            const dtls = new Details(addressdata, CompanyDatas, cardData, soldtos);

            updateState(dispatch, types.GET_PAYER_DETAILS_SUCCESS, dtls);
          }
        }
      }
    )
    .catch(err => {
      if (err && err.response && err.response.statusText === 'Unauthorized') {
        requestUnauthorized(dispatch, err);
      } else {
        requestErrored(dispatch, err, validationTypes.GET_PAYER_DETAILS_ERROR);
      }
    });
}

export function makePayment(dispatch, paymentDetail, next = () =>{}) {
  requestStarted(dispatch, types.POST_PAYMENT_REQUEST);

  return axios
    .post(apiTypes.PAYMENT_URL, paymentDetail)
    .then(response => {
      if (response.status === 200) {
        if (response.data == null || !response.data.status) {
          throw ("Invalid status.")
        }
        const paymentStatuses = response.data.status.map((status, i) => {
          let authorizationReferenceCode = '';
          let documentNumberFinance = '';
          if (status && status.message_type === 'S' && response.data.payed && response.data.payed[i]) {
            authorizationReferenceCode = response.data.payed[i].authorization_reference_code;
            documentNumberFinance = response.data.payed[i].document_number_finance;
          }
          return new PaymentStatus(
            i + 1,
            documentNumberFinance,
            status.message_type,
            status.message_line_string,
            authorizationReferenceCode
          );
         
        });
      

      // Order matters here.
      updateState(dispatch, types.POST_PAYMENT_SUCCESS, paymentStatuses);
      next();
      updateState(dispatch, types.COPY_SELECTED_INVOICES_TO_COMPLETED, null);
      if (paymentStatuses.filter(i => i.message_type === 'S').length > 0) {
        updateState(dispatch, types.CLEAR_SELECTED_INVOICES, null);
        return true;
      } 
      return false;
    }
}).catch(err => {
  if (err && err.response && err.response.statusText === 'Unauthorized') {
    requestUnauthorized(dispatch, err);
  } else {
    requestErrored(dispatch, err, validationTypes.MAKE_PAYMENT_ERROR);
  }
});
}

export function getCustomData(dispatch) {

  axios
    .post(apiTypes.CUSTOM_DATA_URL, '')
    .then(response => {
      if (response.status === 200 && response.data) {
        updateState(dispatch, types.GET_CUSTOM_DATA_SUCCESS, response.data);
        if (response.data.payment_types) {
          for (let i = 0; i < response.data.payment_types.length; i += 1) {
            const paymentType = response.data.payment_types[i];
            if (paymentType.payment_type && paymentType.payment_type === 'O') {
              updateState(dispatch, types.UPDATE_OVER_PAYMENT_ALLOWED_FLAG, paymentType.overpayment_allowed);

              updateState(dispatch, types.UPDATE_REASON_NOT_REQUIRED_FLAG, paymentType.reason_not_required);

              break;
            }
          }
        }

        if (response.data.generel_data) {
          if (response.data.generel_data.partial_payments_allowed) {
            updateState(
              dispatch,
              types.UPDATE_PARTIAL_PAYMENT_ALLOWED_FLAG,
              response.data.generel_data.partial_payments_allowed
            );
          }
          if (response.data.generel_data.cvv_use_control) {
            updateState(dispatch, types.UPDATE_CVV_CONTROL_FLAG, response.data.generel_data.cvv_use_control === '1');
          }
        }
      }
    })
    .catch(err => {
      if (err && err.response && err.response.statusText === 'Unauthorized') {
        requestUnauthorized(dispatch, err);
      } else {
        requestErrored(dispatch, err, validationTypes.GET_CONFIG_ERROR);
      }
    });
}


export function getInvoiceDetail(dispatch, billingDocumentNumber, documentType) {

  const body = {
    'document_detail': {
      'billing_document_number': `${billingDocumentNumber}`,
      'document_type': `${documentType}`
    }
  };
  return axios
    .post(apiTypes.INVOICE_DETAIL_URL, body)
    .then((invoiceDetail) => {
      if (invoiceDetail.status === 200 && invoiceDetail.data) {
        if (invoiceDetail.data.status) {
          if (invoiceDetail.data.status.message_type === 'S') {
            return invoiceDetail.data.detail;
          } else if (invoiceDetail.data.status.message_type === 'E') {
            toast.warn(invoiceDetail.data.status.message_line_string, {position: toast.POSITION.TOP_RIGHT});
            return null;
          }
        }
      }
      return null;
    })
    .catch((err) => {
      if (err && err.response && err.response.statusText === 'Unauthorized') {
        requestErrored(dispatch, err, validationTypes.CREDENTIALS_INVALID);
      } else {
        requestErrored(dispatch, err, validationTypes.GET_INVOICE_DETAIL_ERROR);
      }
      return err;
    });
}

export function updateSecondaryAccounts(dispatch, secondaryAccounts) {
  updateState(dispatch, types.UPDATE_CUSTOMER_OPTIONS, secondaryAccounts);
}

export function updateSelectedSecondaryAccountValue(dispatch, customerOptionValue, cb = () => {
}) {
  updateState(dispatch, types.UPDATE_SELECTED_CUSTOMER_VALUE, customerOptionValue, cb);
}

export function updatePrimaryAccount(dispatch, selectedPrimaryAccountIndex, setSecondary = true) {
  updateState(dispatch, types.SET_SELECTED_ACCOUNT, {selectedPrimaryAccountIndex, setSecondary});
}

export function addSoldTos(dispatch, selectedSoldTo) {
  updateState(dispatch, types.ADD_SELECTED_SOLDTO, selectedSoldTo);
}

export function updateCVV(dispatch, cvvValue) {
  updateState(dispatch, types.UPDATE_CVV, cvvValue);
}

export function updateSelectedCard(dispatch, selectedCard) {
  updateState(dispatch, types.UPDATE_SELECTED_CARD, selectedCard);
}

export function updateInvoiceSearchDueToDate(dispatch, dueToDate) {
  updateState(dispatch, types.INVOICE_SEARCH_DUE_TO_DATE, dueToDate);
}

export function addSoldToToSelected(soldToNumber) {
  return {
    type: types.ADD_SOLD_TO_TO_SELECTED,
    payload: soldToNumber
  };
}

export function removeSoldToFromSelected(soldToNumber) {
  return {
    type: types.REMOVE_SOLD_TO_FROM_SELECTED,
    payload: soldToNumber
  };
}

export function setSelectedSoldTos(soldToNumbers) {
  return {
    type: types.SET_SELECTED_SOLD_TOS,
    payload: soldToNumbers
  };
}

export function makeDeposit(dispatch, paymentDetail) {
  requestStarted(dispatch, types.POST_PAYMENT_REQUEST);

  return axios
    .post(apiTypes.DEPOSIT_URL, paymentDetail)
    .then(response => {
      if (response.status === 200) {
        const paymentStatuses = [];
        if (response.data && response.data.status) {
          for (let i = 0; i < response.data.status.length; i += 1) {
            const status = response.data.status[i];
            let authorizationReferenceCode = '';
            let documentNumberFinance = '';
            if (status && status.message_type === 'S' && response.data.payed && response.data.payed[i]) {
              authorizationReferenceCode = response.data.payed[i].authorization_reference_code;
              documentNumberFinance = response.data.payed[i].document_number_finance;
            }
            const paymentStatus = new PaymentStatus(
              i + 1,
              documentNumberFinance,
              status.message_type,
              status.message_line_string,
              authorizationReferenceCode
            );
            paymentStatuses.push(paymentStatus);
          }
        }

        // Order matters here.
        updateState(dispatch, types.POST_PAYMENT_SUCCESS, paymentStatuses);
      }
    })
    .catch(err => {
      if (err && err.response && err.response.statusText === 'Unauthorized') {
        requestUnauthorized(dispatch, err);
      } else {
        requestErrored(dispatch, err, validationTypes.MAKE_PAYMENT_ERROR);
      }
    });
}

export function clearSelectedInvoices(dispatch) {
  updateState(dispatch, types.CLEAR_SELECTED_INVOICES, null);
}

export function updateAccountTypes(dispatch, accountType) {
  updateState(dispatch, types.UPDATE_ACCOUNT_TYPES, accountType);
}

export function updatePrimaryAccountTypes(dispatch, primaryAccountType) {
  updateState(dispatch, types.UPDATE_PRIMARY_ACCOUNT_TYPES, primaryAccountType);
}

export function updateInvoiceSearchQuery(dispatch, search_parameters) {
    updateState(dispatch, types.UPDATE_INVOICE_SEARCH_QUERY, search_parameters);

}

export function updateInvoiceListQuery(dispatch, search_parameters) {
    updateState(dispatch, types.UPDATE_INVOICE_LIST_REQUEST, search_parameters);
}